import features from '~/featuresWithDefaults';
import {
  AppStoreBadgeAFZAIcon,
  AppStoreBadgeARAEIcon,
  AppStoreBadgeAREGIcon,
  AppStoreBadgeARJOIcon,
  AppStoreBadgeARMAIcon,
  AppStoreBadgeARSAIcon,
  AppStoreBadgeDEDEIcon,
  AppStoreBadgeENGBIcon,
  AppStoreBadgeENUSIcon,
  AppStoreBadgeESESIcon,
  AppStoreBadgeESMXIcon,
  AppStoreBadgeFRCAIcon,
  AppStoreBadgeFRFRIcon,
  AppStoreBadgeITITIcon,
  AppStoreBadgePTBRIcon,
  AppStoreBadgeROROIcon,
  AppStoreBadgeRURUIcon,
  AppStoreBadgeSWKEIcon,
  AppStoreBadgeTRTRIcon,
  AppStoreBadgeYONGIcon,
  GooglePlayBadgeAFZAIcon,
  GooglePlayBadgeARAEIcon,
  GooglePlayBadgeAREGIcon,
  GooglePlayBadgeARJOIcon,
  GooglePlayBadgeARMAIcon,
  GooglePlayBadgeARSAIcon,
  GooglePlayBadgeDEDEIcon,
  GooglePlayBadgeENGBIcon,
  GooglePlayBadgeENUSIcon,
  GooglePlayBadgeESESIcon,
  GooglePlayBadgeESMXIcon,
  GooglePlayBadgeFRCAIcon,
  GooglePlayBadgeFRFRIcon,
  GooglePlayBadgeITITIcon,
  GooglePlayBadgePTBRIcon,
  GooglePlayBadgeROROIcon,
  GooglePlayBadgeRURUIcon,
  GooglePlayBadgeSWKEIcon,
  GooglePlayBadgeTRTRIcon,
  GooglePlayBadgeYONGIcon,
} from '~/img';
import React from 'react';

const afZA = 'af-ZA';
const arAE = 'ar-AE';
const arEG = 'ar-EG';
const arJO = 'ar-JO';
const arMA = 'ar-MA';
const arSA = 'ar-SA';
const deDE = 'de-DE';
const enGB = 'en-GB';
const enUS = 'en-US';
const esES = 'es-ES';
const esMX = 'es-MX';
const frCA = 'fr-CA';
const frFR = 'fr-FR';
const itIT = 'it-IT';
const ptBR = 'pt-BR';
const roRO = 'ro-RO';
const ruRU = 'ru-RU';
const swKE = 'sw-KE';
const trTR = 'tr-TR';
const yoNG = 'yo-NG';
export const languagesConfig: Record<
  string,
  {
    numberIntlLocale: string;
    momentLocale: string;
    isRTL: boolean;
    captchaLocale: string;
    antdLocale: () => Promise<any>;
    appStoreIcon: JSX.Element;
    googlePlayIcon: JSX.Element;
  }
> = {
  [afZA]: {
    numberIntlLocale: 'af-ZA',
    momentLocale: 'af',
    isRTL: false,
    captchaLocale: 'af',
    antdLocale: () => import('antd/lib/locale/en_US'),
    appStoreIcon: React.createElement(AppStoreBadgeAFZAIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeAFZAIcon),
  },
  [arAE]: {
    numberIntlLocale: 'ar-AE',
    momentLocale: 'ar',
    isRTL: true,
    captchaLocale: 'ar',
    antdLocale: () => import('antd/lib/locale/ar_EG'),
    appStoreIcon: React.createElement(AppStoreBadgeARAEIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeARAEIcon),
  },
  [arEG]: {
    numberIntlLocale: 'ar-EG',
    momentLocale: 'ar',
    isRTL: true,
    captchaLocale: 'ar',
    antdLocale: () => import('antd/lib/locale/ar_EG'),
    appStoreIcon: React.createElement(AppStoreBadgeAREGIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeAREGIcon),
  },
  [arJO]: {
    numberIntlLocale: 'ar-JO',
    momentLocale: 'ar',
    isRTL: true,
    captchaLocale: 'ar',
    antdLocale: () => import('antd/lib/locale/ar_EG'),
    appStoreIcon: React.createElement(AppStoreBadgeARJOIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeARJOIcon),
  },
  [arMA]: {
    numberIntlLocale: 'ar-MA',
    momentLocale: 'ar-ma',
    isRTL: true,
    captchaLocale: 'ar',
    antdLocale: () => import('antd/lib/locale/ar_EG'),
    appStoreIcon: React.createElement(AppStoreBadgeARMAIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeARMAIcon),
  },
  [arSA]: {
    numberIntlLocale: 'ar-SA',
    momentLocale: 'ar-sa',
    isRTL: true,
    captchaLocale: 'ar',
    antdLocale: () => import('antd/lib/locale/ar_EG'),
    appStoreIcon: React.createElement(AppStoreBadgeARSAIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeARSAIcon),
  },
  [deDE]: {
    numberIntlLocale: 'de',
    momentLocale: 'de',
    isRTL: false,
    captchaLocale: 'de',
    antdLocale: () => import('antd/lib/locale/de_DE'),
    appStoreIcon: React.createElement(AppStoreBadgeDEDEIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeDEDEIcon),
  },
  [enGB]: {
    numberIntlLocale: 'en-GB',
    momentLocale: 'en-gb',
    isRTL: false,
    captchaLocale: 'en-GB',
    antdLocale: () => import('antd/lib/locale/en_GB'),
    appStoreIcon: React.createElement(AppStoreBadgeENGBIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeENGBIcon),
  },
  [enUS]: {
    numberIntlLocale: 'en',
    momentLocale: 'en',
    isRTL: false,
    captchaLocale: 'en',
    antdLocale: () => import('antd/lib/locale/en_US'),
    appStoreIcon: React.createElement(AppStoreBadgeENUSIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeENUSIcon),
  },
  [esES]: {
    numberIntlLocale: 'es',
    momentLocale: 'es',
    isRTL: false,
    captchaLocale: 'es',
    antdLocale: () => import('antd/lib/locale/es_ES'),
    appStoreIcon: React.createElement(AppStoreBadgeESESIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeESESIcon),
  },
  [esMX]: {
    numberIntlLocale: 'es-MX',
    momentLocale: 'es-mx',
    isRTL: false,
    captchaLocale: 'es',
    antdLocale: () => import('antd/lib/locale/es_ES'),
    appStoreIcon: React.createElement(AppStoreBadgeESMXIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeESMXIcon),
  },
  [frCA]: {
    numberIntlLocale: 'fr-CA',
    momentLocale: 'fr-ca',
    isRTL: false,
    captchaLocale: 'fr-CA',
    antdLocale: () => import('antd/lib/locale/fr_CA'),
    appStoreIcon: React.createElement(AppStoreBadgeFRCAIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeFRCAIcon),
  },
  [frFR]: {
    numberIntlLocale: 'fr',
    momentLocale: 'fr',
    isRTL: false,
    captchaLocale: 'fr',
    antdLocale: () => import('antd/lib/locale/fr_FR'),
    appStoreIcon: React.createElement(AppStoreBadgeFRFRIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeFRFRIcon),
  },
  [itIT]: {
    numberIntlLocale: 'it',
    momentLocale: 'it',
    isRTL: false,
    captchaLocale: 'it',
    antdLocale: () => import('antd/lib/locale/it_IT'),
    appStoreIcon: React.createElement(AppStoreBadgeITITIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeITITIcon),
  },
  [ptBR]: {
    numberIntlLocale: 'pt-BR',
    momentLocale: 'pt-br',
    isRTL: false,
    captchaLocale: 'pt-BR',
    antdLocale: () => import('antd/lib/locale/pt_BR'),
    appStoreIcon: React.createElement(AppStoreBadgePTBRIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgePTBRIcon),
  },
  [roRO]: {
    numberIntlLocale: 'ro',
    momentLocale: 'ro',
    isRTL: false,
    captchaLocale: 'ro',
    antdLocale: () => import('antd/lib/locale/ro_RO'),
    appStoreIcon: React.createElement(AppStoreBadgeROROIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeROROIcon),
  },
  [ruRU]: {
    numberIntlLocale: 'ru',
    momentLocale: 'ru',
    isRTL: false,
    captchaLocale: 'ru',
    antdLocale: () => import('antd/lib/locale/ru_RU'),
    appStoreIcon: React.createElement(AppStoreBadgeRURUIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeRURUIcon),
  },
  [swKE]: {
    numberIntlLocale: 'sw-KE',
    momentLocale: 'sw',
    isRTL: false,
    captchaLocale: 'sw',
    antdLocale: () => import('antd/lib/locale/en_US'),
    appStoreIcon: React.createElement(AppStoreBadgeSWKEIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeSWKEIcon),
  },
  [trTR]: {
    numberIntlLocale: 'tr',
    momentLocale: 'tr',
    isRTL: false,
    captchaLocale: 'tr',
    antdLocale: () => import('antd/lib/locale/tr_TR'),
    appStoreIcon: React.createElement(AppStoreBadgeTRTRIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeTRTRIcon),
  },
  [yoNG]: {
    numberIntlLocale: 'yo-NG',
    momentLocale: 'yo',
    isRTL: false,
    captchaLocale: 'en',
    antdLocale: () => import('antd/lib/locale/en_US'),
    appStoreIcon: React.createElement(AppStoreBadgeYONGIcon),
    googlePlayIcon: React.createElement(GooglePlayBadgeYONGIcon),
  },
};

export const initMomentLocales = () => {
  features.i18n.userLanguages.forEach((feature) => {
    const momentLocale = languagesConfig[feature].momentLocale;
    if (momentLocale !== 'en') {
      require(`moment/locale/${momentLocale}`);
    }
  });
};
